export {
    Type,
    JSON_DISCRIMINATOR,
    Serializable,
    toTypedJSON,
    toUnwrappedJSON,
    fromUnwrappedJSON,
    fromTypedJSON,
    instanceOf,
    fromSerializable,
    toSerializable,
    create,
} from '../../types/Energy.js';
